import { Component, Inject, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { CommonService } from 'src/app/core/services/common.service';
import { NeverBounceService } from 'src/app/core/services/neverbounce.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss']
})

export class UserRegistrationComponent implements OnInit {
  loading: boolean;
  registrationForm: UntypedFormGroup;
  emailPattern: string = "^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$";
  isRegistered: boolean = false;
  auth = ''
  key = ''
  gotocart = false
  isGuest = false
  inputText: string = '';
  constructor(
    private formBuilder: UntypedFormBuilder,
    private userService: UserService,
    private commonService: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    //private nbService: NeverBounceService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any = null,
    @Optional() public dialogRef: MatDialogRef<UserRegistrationComponent> = null,
  ) { }

  ngOnInit() {
    this.auth = this.route.snapshot.queryParams['auth'] || ''
    this.key = this.route.snapshot.queryParams['key'] || ''
    this.gotocart = this.route.snapshot.queryParams['gotocart'] || false
    this.isGuest = this.route.snapshot.queryParams['isGuest']
    if (this.auth && this.key) {
      this.getUser()
    }
    let user
    if (this.isGuest)
      user = JSON.parse(localStorage.getItem('user'))
    this.setUpCreateUserForm(user);
    //this.nbService.loadScript();

    if (this.data) {
      this.setUpCreateUserForm(this.data);
    }

  }

  // onBlur(event: FocusEvent): void {
  //   const input = event.target as HTMLInputElement;

  //   if (!input) {
  //     console.warn('⚠️ No input target found on blur.');
  //     return;
  //   }

  //   this.nbService.validateInput(input).catch(err => {
  //     console.warn('NeverBounce validation skipped:', err);
  //   });
  // }

  onInputChange() {
    this.registrationForm.value.email = this.inputText.toLowerCase();
    this.inputText = this.registrationForm.value.email
  }
  onKeyDownOfPhone(event) {
    const ignoreKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Delete', 'Tab']
    if (event.key == ' ')
      return false
    else if (ignoreKeys.includes(event.key))
      return true
    else if (this.registrationForm.get('phoneNumber').value.length >= 14)
      return false
    for (let i = 0; i < 10; i++) {
      if (i == event.key)
        return true
    }
    return false
  }
  onKeyUpOfPhone(event?) {
    const ignoreKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Delete', 'Tab']
    if (event && ignoreKeys.includes(event.key))
      return
    const regEx = /([^0-9])/g
    let phoneString = this.registrationForm.get('phoneNumber').value
    phoneString = phoneString.replace(regEx, '')
    let newPhoneString = ''
    if (phoneString.length > 0)
      newPhoneString += "(" + phoneString.substr(0, 3)
    if (phoneString.length > 3)
      newPhoneString += ") " + phoneString.substr(3, 3)
    if (phoneString.length > 6)
      newPhoneString += "-" + phoneString.substr(6, 4)
    this.registrationForm.get('phoneNumber').setValue(newPhoneString)
  }
  setUpCreateUserForm(user?) {
    user = user || {}
    this.registrationForm = this.formBuilder.group({
      email: new UntypedFormControl(user.email || '', [
        Validators.required,
        Validators.pattern(this.emailPattern)]
      ),
      password: new UntypedFormControl('', Validators.required),
      confirmPassword: new UntypedFormControl('', Validators.required),
      phoneNumber: new UntypedFormControl(user.phoneNumber || ''),
      firstName: new UntypedFormControl(user.firstName || '', Validators.required),
      lastName: new UntypedFormControl(user.lastName || '', Validators.required),
      // gender: ['Male'],
      otp: new UntypedFormControl('')
    });
    this.inputText = user?.email ? user?.email : ''
  }

  createUser() {
    if (this.registrationForm.valid) {
      if (this.registrationForm.value.password != this.registrationForm.value.confirmPassword) {
        this.commonService.openErrorSnackBar("Password do not match!", "");
        return;
      }
      let password: String = this.registrationForm.value.password;
      if (password.length < 5) {
        this.commonService.openErrorSnackBar("Password at least 5 characters!", "");
        return;
      }
      this.userService.createUser(this.registrationForm.value).subscribe(
        (response) => {
          this.commonService.openSuccessSnackBar(response.message, "");
          this.isRegistered = true;
        },
        (error) => {
          this.commonService.openErrorSnackBar(error.error.message, "");
        }
      );
    }

  }

  trimName() {
    this.registrationForm.patchValue({
      firstName: this.registrationForm.value.firstName.trim(),
      lastName: this.registrationForm.value.lastName.trim(),
    })
  }

  resendOtp() {
    if (this.registrationForm.value.password != this.registrationForm.value.confirmPassword) {
      this.commonService.openErrorSnackBar("Password do not match!", "");
      return;
    }
    let password: String = this.registrationForm.value.password;
    if (password.length < 5) {
      this.commonService.openErrorSnackBar("Password at least 5 characters!", "");
      return;
    }
    this.userService.resendOtp(this.registrationForm.value.email).subscribe(
      (response) => {
        this.commonService.openSuccessSnackBar("OTP has been resend to the email", "");
      },
      (error) => {
        this.commonService.openErrorSnackBar(error.error.message, "");
      }
    );
  }

  verifyUser() {
    this.userService.verifyUser(this.registrationForm.value).subscribe(
      (response) => {
        this.commonService.openSuccessSnackBar(response.message, "");
        this.autoLogin(this.registrationForm.value.email, this.registrationForm.value.password)
        // this.router.navigateByUrl('enduser/login');
      },
      (error) => {
        this.commonService.openErrorSnackBar(error.error.message, "");
      }
    );
  }

  login() {
    this.router.navigateByUrl('enduser/login');
  }

  autoLogin(email, password) {

    let role: any;
    let isAuthorized = false;
    this.authenticationService.login({ email, password }).subscribe(
      data => {
        window.top.postMessage("cart count-" + data.cartTotal, "*");
        // role = data.user.roles[0];
        //isAuthorized = role.name === "ENDUSER";
        isAuthorized = data.user.isEmailConfirmed
        if (isAuthorized) {
          if (this.data) {
            this.dialogRef.close();
            this.router.navigateByUrl('enduser/useraccount/my-stores');
            window.parent.postMessage(data, "*");
          }

          window.parent.postMessage(data, "*");
          window.parent.postMessage("close popup", "*")

        } else {
          this.commonService.openErrorSnackBar("Authorization failed", "");
          this.loading = false;
        }
      },
      error => {
        this.commonService.openErrorSnackBar(error.error.message, "");
        this.loading = false;
      });
  }


  getUser() {
    this.authenticationService.getUserByAuthKey(this.auth, this.key).subscribe(res => {
      if (res.data.emailConfirmed === false) {
        this.registrationForm = this.formBuilder.group({
          email: new UntypedFormControl(res.data.email, [
            Validators.required,
            Validators.pattern(this.emailPattern)]
          ),
          password: new UntypedFormControl('', Validators.required),
          confirmPassword: new UntypedFormControl('', Validators.required),
          phoneNumber: res.data.phoneNumber,
          firstName: new UntypedFormControl(res.data.firstName, Validators.required),
          lastName: new UntypedFormControl(res.data.lastName, Validators.required),
          // gender: ['Male'],
          otp: new UntypedFormControl('')
        });

        console.log(this.registrationForm.value)
      }
    })
    // if(this.userObj){

    // }
  }
}
